const billCategoryUpdateSelectedHorses = new Set();

export function showInvoicePDF({ invoiceNumber = '', controlLevelID = ''} = {}){
    // Helper function to handle most common click event, open PDF
    getInvoiceURL({
        invoiceNumber: invoiceNumber,
        controlLevelID: controlLevelID,
        onSuccess: function(data){
            if (!data.success){
                EQLAPP.STRIPE.showAlert({
                    title: 'Invoice PDF',
                    body: data.message,
                });
                return;
            }

            window.open(data.sasURL);
        },
        onError: function(){
            console.log('Unable to get Invoice URL');
        },
    });
}

export function horseBillingCategoryReloadGrid(){
    var $billingCategoryUpdatePage = $('#billingCategoryUpdatePageContainer');

    var gridFilters = $billingCategoryUpdatePage.find('.js-grid_filters');
    var jqGridName = $billingCategoryUpdatePage.find('#jq_daily');

    var statusid = gridFilters.find('[name="filter_status_id"]').val();
    var billCategoryid = gridFilters.find('[name="bill_category_id"]').val();
    var lastMovement = 0;
    if (gridFilters.find('[name="ignoreMovements"]:checked').val() == 'on'){
        lastMovement = 0;
    } else {
        lastMovement = gridFilters.find('[name="LastMovements"]:checked').val();
    }

    var searchURL = '/components/horse.cfc?' + jQuery.param({
        'method': 'getHorseDetails',
        'jqGrid': 'true',
        'jqGridType': 'billingCategoryUpdate',
        'includeBillingCategoryUpdate': 'true',
        'Status_ID': statusid,
        'billCategoryID': billCategoryid,
        'lastMovementToExternal': lastMovement,
        'recordType': 'NonPedigreeOnly',
    });

    resetBillCategoryUpdateSelectedHorses();

    //Reload Grid using Search Criteria URL
    jqGridName.jqGrid('setGridParam',{
        url: searchURL,
        page: 1,
        datatype: 'json'}).trigger('reloadGrid');

}

export function getInvoiceURL({ invoiceNumber = '', controlLevelID = '',
    onSuccess = '', onError} = {}){

    var getInvoicePDFDetailsURL = '/components/invoice.cfc/?' + jQuery.param({
        method: 'getInvoicePDFWeb',
        invoiceNumber: invoiceNumber,
        ControlLevel_ID: controlLevelID,
    });

    if (!isFunction(onSuccess)) {
        throw new Error('onSuccess must be a function');
    }

    if (!isFunction(onError)){
        throw new Error('onError must be a function');
    }

    $.ajax({
        type: 'GET',
        url: getInvoicePDFDetailsURL,
        contentType: 'application/json',
        cache: false,
        success: onSuccess,
        error: onError,
    });

}

export function commitInvoicesToHistory({
    formID,
    savingText = 'Saving',
    importText1 = 'Commiting To History',
    loaderAltText = 'Commiting Invoices to History',
    loaderID = 'loader_frm_billing' } = {}){

    if (!formID) {
        throw new Error("'formID' is required and was not provided.");
    }

    var $frmObj = $('#' + formID);
    if ($frmObj.length < 1){
        throw new Error('No matching form exists for this form ID.');
    }

    var btnSaveText = $frmObj.find("[name='btnSubmit']").find('.ui-button-text');

    if (btnSaveText.text() != savingText){

        createLoader(
            '#' + loaderID,
            importText1,
            loaderAltText,
        );

        $frmObj.find("[name='btnCancel']").customHide();
        btnSaveText.html(savingText);

        var serializedForm = $frmObj.serialize();
        var postURL = '/components/general.cfc?method=saveForm&randomVar=' + gen_random();

        $.ajax({
            type: 'POST',
            url: postURL,
            data: serializedForm,
            cache: false,
            success: function(result){

                $('#' + loaderID)
                    .find('.mainText')
                    .text('Invoices Commited. Creating PDFs. Please wait...');

                try {
                    var jsonResult = JSON.parse(result);

                    if (jsonResult.SAVED === 'true'){
                        popWinClose('billingPopCommitInvoices');

                        var postURL = '/components/invoice.cfc?' + jQuery.param({
                            method: 'createFromWeb',
                        });

                        var postData = {
                            billingCentreID: jsonResult.BILLINGCENTRE_ID,
                            batchNumber: jsonResult.BATCHNUMBER,
                            reportFormat: 'email',
                            reportName: 'billing_invoice_reprint',
                        };

                        $.ajax({
                            type: 'POST',
                            url: postURL,
                            data: postData,
                            dataType: 'JSON',
                            cache: false,
                            success: function(data, _textStatus , _jqXHR){

                                if (!data.SUCCESS){
                                    EQLAPP.STRIPE.showAlert({
                                        title: 'Create Invoice Error',
                                        body: data.MESSAGE,
                                    });
                                    return;
                                }

                                if (data.REDIRECTURL.length > 0){
                                    window.location = data.REDIRECTURL;
                                } else {
                                    // Should never reach here as redirect URL
                                    // should always be set if successful
                                    popWinClose('popInvoicesGenerating');
                                    EQLAPP.STRIPE.showAlert({
                                        title: 'Invoices Created',
                                        body: 'Invoices Created',
                                    });
                                }
                            },
                            error: function(){
                                popWinClose('popInvoicesGenerating');
                                EQLAPP.STRIPE.showAlert({
                                    title: 'Alert',
                                    body: 'Unable to connect to Equisoft Live at this time.' +
                                        'Please try again.',
                                });
                            },
                        });

                    } else {
                        showHideItem('showHideItem', '.loader');
                        popWinClose('billingPopCommitInvoices');
                        var errorMessage;
                        if (jsonResult.RESULTMSG?.length > 0){
                            errorMessage = jsonResult.RESULTMSG;
                            EQLAPP.STRIPE.showAlert({
                                title: 'Save Error',
                                body: errorMessage,
                            });
                        } else {
                            throw new Error('An unknown error occured while saving.'
                                + ' Please try again');
                        };
                    }
                } catch (error) {
                    console.error('Error committing invoices:', error);
                    EQLAPP.STRIPE.showAlert({
                        title: 'Result Error',
                        body: 'Unable to parse response. Please Try Again.',
                    });
                }

            },
            error: function(){
                EQLAPP.STRIPE.showAlert({
                    title: 'Network Error',
                    body: 'Network Error. Please Try Again.',
                });
                showHideItem('showHideItem', '.loader');
            },
        });

    } else {
        EQLAPP.STRIPE.showAlert({
            title: 'Alert',
            body: 'Saving. Please wait...',
        });
    }

}

export function populateBillingDates(billingCentreSelector, invoiceDateSelector, onPopulated, invoiceType){

    var billingCentreId = $(billingCentreSelector).val();

    if (billingCentreId == null){
        console.log('Invalid Billing Centre');
        return;
    }

    var invoiceDateUrl = '/components/ledger.cfc?method=getInvoiceHistoryDates';
    invoiceDateUrl += '&billingCentreId=' + encodeURIComponent(billingCentreId);
    invoiceDateUrl += '&invoiceType=' + encodeURIComponent(invoiceType || 'keep');

    $.ajax({
        type: 'GET',
        url: invoiceDateUrl,
        data: gen_random(),
        dataType: 'JSON',
        cache: false,
        success: function(data){
            var $dropDownObj = $(invoiceDateSelector);

            $dropDownObj.empty();

            if (data.length < 1){
                $dropDownObj.append('<option value="">::No Invoices::</option>')
                    .attr('disabled','disabled');
                $('.js-format').customHide();
            } else {
                $dropDownObj.append('<option value="">::Choose Date::</option>')
                    .removeAttr('disabled');
                $('.js-format').customShow();
            }

            for (var i = 0; i < data.length; i++){
                // Create a new option element
                const option = document.createElement('option');
                option.value = data[i][1];
                option.text = data[i][0];
                // Append the option to the select element
                $dropDownObj.append(option);
            }

            if (typeof onPopulated !== 'undefined') {
                onPopulated();
            }

        },
        error: function(){
            console.log('Failed to populate items');
        },
    });
}

export function paymentRegisterGrid(options){

    if (!options.invoiceMethod){
        options.invoiceMethod = '';
    };

    if (!options.gridURL){
        //EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid URL Missing'});return false;
    };
    if (!options.type){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid type Missing'});return false;
    };
    if (!options.selector){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid Object Missing'});return false;
    };
    if (!options.grid){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid Name Missing'});return false;
    };
    if (!options.pager){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Pager Name Missing'});return false;
    };
    if (!options.multiBillingCentres){
        options.multiBillingCentres = false;
    };
    if (!options.pagerSetting){
        EQLAPP.STRIPE.showAlert({title: 'Alert',
            body: 'Pager Setting Name Missing',
        });return false;
    };
    if (!options.startRows){
        options.startRows = 10;
    };
    if (!options.width){
        options.width = 730;
    };

    $(options.selector).jqGrid({
        datatype: 'local',
        caption: '',
        autowidth: false,
        width: options.width,
        height: '100%',
        pager: options.pager,
        colNames: [
            $.i18n('BILLING_CENTRE'),
            $.i18n(''),
            $.i18n('OWNER_ID'),
            $.i18n(''),
            $.i18n('Type'),
            $.i18n(''),
            $.i18n('DATE'),
            $.i18n('INVOICE'),
            $.i18n('OWNER'),
            $.i18n('DESCRIPTION'),
            $.i18n('SQL_DATE'),
            $.i18n('INVOICE_TYPE'),
            $.i18n('AMOUNT'),
            $.i18n('DATEPAID'),
            $.i18n('PAID'),
            $.i18n('PRINT'),
            $.i18n('EDIT'),
            $.i18n('CLR'),
        ],
        colModel: [
            {
                name: 'BILLINGCENTRE', index: 'BILLINGCENTRE',
                align: 'left', width: 15,hidden: true,
            },
            {
                name: 'COMPANYNAME', index: 'COMPANYNAME',
                align: 'left', width: 15,hidden: true,
            },
            {
                name: 'OWNERID', index: 'OWNERID',
                align: 'left', width: 15,hidden: true,
            },
            {
                name: 'BILLINGCENTRECOLOUR', index: 'BILLINGCENTRECOLOUR',
                align: 'left', search: true, width: 1, sorttype: 'text',
                hidden: !options.multiBillingCentres,
                searchoptions: {dataInit: resizeFilterToolbarInput },
                cellattr: function (rowId, val, rawObject) {
                    return ' style="background-color:' + rawObject.BILLINGCENTRECOLOUR + ';"';
                },
                formatter: function () {
                    return '';
                },
            },
            {
                name: 'INVOICETYPE', index: 'INVOICETYPE',
                align: 'left', width: 4, hidden: false,
            },
            {
                name: 'INVOICETYPEID', index: 'INVOICETYPEID',
                align: 'left', width: 4, hidden: true,
            },
            {
                name: 'INVOICEDATE', index: 'INVOICEDATE',
                align: 'center', sorttype: 'int', width: 10,editable: false,
                searchoptions: {sopt: ['bw']},
            },
            {
                name: 'INVOICENO', index: 'INVOICENO',
                align: 'left', search: true, width: 7, sorttype: 'text',
                classes: 'nowrap horse_search',
                searchoptions: {dataInit: resizeFilterToolbarInput},
            },
            {
                name: 'OWNERNAME', index: 'OWNERNAME',
                align: 'left', search: true, width: 20, sorttype: 'text',
                classes: 'nowrap horse_search',
                hidden: (options.type != 'Register'),
                searchoptions: {dataInit: resizeFilterToolbarInput},
            },
            {
                name: 'INVOICEDESCRIPTION', index: 'INVOICEDESCRIPTION',
                align: 'left', search: true,width: 17, sorttype: 'text',
                classes: 'horse_search',
                searchoptions: {dataInit: resizeFilterToolbarInput},
            },
            {
                name: 'SQLDATE', index: 'SQLDATE',
                align: 'left', width: 15,hidden: true,
            },
            {
                name: 'INVOICETYPE', index: 'INVOICETYPE',
                align: 'left', hidden: true, search: true, width: 10, sorttype: 'text',
                classes: 'nowrap horse_search',
                searchoptions: {dataInit: resizeFilterToolbarInput },
            },
            {
                name: 'AMOUNT', index: 'AMOUNT',
                align: 'right', formatter: 'currency', width: 10,sorttype: 'text',
            },
            {
                name: 'DATEPAID', index: 'DATEPAID',
                align: 'center', width: 10,sorttype: 'text',
                cellattr: function(rowId,val, rawObject){
                    if (rowId > 0){
                        if (rawObject.DATEPAID.length){
                            return 'class="OwnerInvoicePaid"';
                        } else {
                            val = 'NO';
                            $(options.selector).jqGrid('setCell', rowId, 'DATEPAID', 'No');
                            return 'class="OwnerInvoiceUnpaid"';
                        }
                    }
                },
            },
            {
                name: 'AMOUNTPAID',index: 'AMOUNTPAID',
                align: 'right', formatter: 'currency',width: 10, sorttype: 'text',
                edittype: 'select',
            },
            {
                name: 'Print', index: 'Print',
                align: 'center', classes: 'option pdf',width: 5, sorttype: 'text',
                edittype: 'select',
                cellattr: function () {
                    return ' title="PDF Invoice"';
                },
            },
            {
                name: 'Edit', index: 'Edit',
                align: 'center', classes: 'option edit', width: 5, sorttype: 'text',
                edittype: 'select',
                cellattr: function () {
                    return ' title="Edit Payment Details"';
                },
            },
            {
                name: 'Delete', index: 'Delete',
                align: 'center', classes: 'option remove', width: 5, sorttype: 'text',
                edittype: 'select',
                cellattr: function(rowId,val,rawObject,cm,rData){
                    if (rowId > 0){
                        if ((rData.DATEPAID.length > 0) || (rData.AMOUNTPAID > 0)){
                            return 'title="Clear Payment Details" class="option remove"';
                        } else {
                            return 'title="" class=""';
                        }
                    }
                },
            },
        ],
        rowNum: options.startRows,
        rowList: [10,15,20],
        gridComplete: function(){
            gridFix(options.selector);
        },
        loadComplete: function(data){
            var recCount = $('#' + options.pager).find('.ui-pg-selbox').val();
            setMiscSetting(options.pagerSetting,recCount);
            if (options.multiBillingCentres){
                if (data.RECORDS > 0){
                    companyColourList(options.selector, '#' + options.pager, data);
                }
                else {
                    $('#colorList').empty();
                }
            }

            // Trigger Resize
            window.dispatchEvent(new Event('resize'));

        },
        onCellSelect: function(rowid,iCol,cellcontent,e){
            var ownerID = $(options.selector).jqGrid('getCell',rowid,'OWNERID');
            var billingCentreID = $(options.selector).jqGrid('getCell',rowid,'BILLINGCENTRE');
            var invoiceId = $(options.selector).jqGrid('getCell',rowid,'INVOICENO');
            var invoiceDate = $(options.selector).jqGrid('getCell',rowid,'SQLDATE');
            var invoiceTypeID = $(options.selector).jqGrid('getCell',rowid,'INVOICETYPEID');
            if (iCol == 15){
                paymentRegisterInvoicePrint(
                    invoiceId,
                    invoiceTypeID,
                    invoiceDate,
                    ownerID,
                    billingCentreID,
                    options.invoiceMethod,
                );
            }

            if (iCol == 16){

                var editURL = '/pages/ajax_gen_win_billing.cfm?' + jQuery.param({
                    'type': 'ownerInvoiceEdit',
                    'gridName': options.grid,
                    'invoiceNo': invoiceId,
                });

                popWin({
                    title: $.i18n('EDIT_PAYMENT'),
                    modal: true,
                    noAutoWidth: true,
                    width: 400,
                    page: editURL,
                });
            }

            if (iCol == 17 && $(e.srcElement).hasClass('remove')){

                var yesButtonText = $.i18n('CLEAR_PAYMENT');
                var closeButtonText = $.i18n('CANCEL');

                var deleteInvoicePaymentURL = '/components/billing.cfc?' + jQuery.param({
                    'method': 'deleteInvoicePayment',
                    'InvoiceNo': invoiceId,
                });

                popWin({
                    title: $.i18n('CLEAR_PAYMENT'),
                    modal: true,
                    classes: 'deletePaymentPopup',
                    contents: $.i18n('CONFIRM_CLEAR'),
                    buttons: {
                        [yesButtonText]: function(){
                            $.ajax({
                                type: 'GET',
                                url: deleteInvoicePaymentURL,
                                dataType: 'json',
                                cache: false,
                                success: function(data){
                                    if (!data.SAVED){
                                        EQLAPP.STRIPE.showAlert({
                                            title: $.i18n('ALERT'),
                                            body: data.RESULTMSG,
                                        });
                                    } else {
                                        popWinClose();
                                        $(options.selector).trigger('reloadGrid');
                                    }
                                },
                            });
                        },
                        [closeButtonText]: function(){
                            popWinClose();
                        },
                    },
                });
            }
        },
    });

    $(options.selector).navGrid(
        '#' + options.pager,
        {
            edit: false,
            add: false,
            del: false,
            search: false,
            refresh: false,
        },
    );

    // here 'pager' part or #pager_left is the id of the pager
    var prResultsPagerHTML = '<td><div>';
    prResultsPagerHTML += '<input type="checkbox" class="unpaidonly" id="registerUnpaidOnly"';
    prResultsPagerHTML += ' name="registerUnpaidOnly"/>';
    prResultsPagerHTML += '<label for="registerUnpaidOnly"> Unpaid Only</label></div></td>';

    $('#' + options.pager + '_left table.navtable tbody tr').append (prResultsPagerHTML);

    $('#registerUnpaidOnly').change(function() {
        if (options.type == 'Register'){
            var gridBaseURL = '/components/billing.cfc?';
        }
        else {
            var gridBaseURL = options.gridURL;
        }
        var frmPaymentRegister = $('#frmPaymentRegister');
        if ($(this).is(':checked')) {
            unpaidOnlyPaymentRegisterToggle(
                options.type,
                true,
                frmPaymentRegister,
                gridBaseURL,
                options.selector,
            );
        } else {
            unpaidOnlyPaymentRegisterToggle(
                options.type,
                false,
                frmPaymentRegister,
                gridBaseURL,
                options.selector,
            );
        }
    });

}

export function companyColourList(selector, pager, data){

    var colorListExists = $('#colorList').length;

    var localData = data;

    if (colorListExists > 0){
        $('#colorList').empty();
    } else {
        var colorDIV = '<div id=colorList class="margin_top colorHorizontal"></div>';
        $(pager).parent().after(colorDIV);
    }

    $.each(localData.COMPANIES,(intIndex, company) =>
    {
        var billingCentreColour = company.COLOUR;
        var companyName = company.NAME;
        var billingCentre = company.ID;

        if (billingCentre > 0)
        {
            var colorItemExists = $('#billCentre' + billingCentre).length;
            if (colorItemExists == 0){
                var clrDiv = '<div class="margin_right" id="billCentre' + billingCentre;
                clrDiv += '">  <div class="companyBlock"><span class="cellWithoutBackground" ';
                clrDiv += 'style="background-color: ' + billingCentreColour + ';"></span>';
                clrDiv += '<span>' + companyName + '</span>';
                clrDiv += '</div></div>';
                $('#colorList').append(clrDiv);
            }
        }
    });
}

export function unpaidOnlyPaymentRegisterToggle(type, unpaid,
    frmPRSearchObj, gridBaseURL, selector){
    if (type == 'Register'){
        var invoiceNoFrom = $(frmPRSearchObj).find("[name='invoiceNoFrom']").val();
        var invoiceNoTo = $(frmPRSearchObj).find("[name='invoiceNoTo']").val();
        var invoiceDateFrom = $(frmPRSearchObj).find("[name='invoiceDateFrom']").val();
        var invoiceDateTo = $(frmPRSearchObj).find("[name='invoiceDateTo']").val();
        var horseIDs = $(frmPRSearchObj).find("[name='horse_id']").val();
        var ownerIDs = $(frmPRSearchObj).find("[name='owner_id']").val();
        var billingCentreID = $(frmPRSearchObj).find('[name="BillingCentreID"]').val();
        var invoiceType = $(frmPRSearchObj).find('[name="invoiceType"]:checked').val();
        var stallionIDs = $(frmPRSearchObj).find("[name='stallion_id']").val();
        if (stallionIDs === undefined) (stallionIDs = '');

        var searchUrl = gridBaseURL + jQuery.param({
            'method': 'getOwnerInvoiceHistory',
            'jqGrid': 'true',
            'invoiceNoFrom': invoiceNoFrom,
            'invoiceNoTo': invoiceNoTo,
            'invoiceDateFrom': invoiceDateFrom,
            'invoiceDateTo': invoiceDateTo,
            'horseIDs': horseIDs,
            'ownerIDs': ownerIDs,
            'billingCentreID': billingCentreID,
            'invoiceType': invoiceType,
            'stallionIDs': stallionIDs,
            'unpaidOnly': unpaid,
        });
        $(selector).jqGrid('setGridParam',{
            url: searchUrl,
            page: 1,
            datatype: 'json'}).trigger('reloadGrid');
    }
    else {
        var unpaidURL = gridBaseURL + '&' + jQuery.param({
            'unpaidOnly': unpaid,
        });

        $(selector).jqGrid('setGridParam',{
            url: unpaidURL,
            page: 1,
            datatype: 'json'}).trigger('reloadGrid');

    }

}

export function paymentRegisterSwitchView(conPRSearchObj,itemToShow){
    switch (itemToShow){
        case 'results':
            conPRSearchObj.customHide();
            conPRResultsObj.customShow();
            break;
        default:
            conPRResultsObj.customHide();
            conPRSearchObj.customShow();
            break;
    }
}

export function paymentRegisterInvoicePrint(
    invoiceID, invoiceType, invoiceDate,
    ownerID, billingCentreID, invoiceMethod,
){

    // V2 Keep Invoice PDF Option
    if (invoiceMethod === 'V2' && invoiceType === 'K'){
        showInvoicePDF({
            invoiceNumber: invoiceID,
            controlLevelID: billingCentreID,
        });
        return;
    }

    var popTitle = 'Generating Invoices';
    var popWaitMessage = 'Invoices are being generated. This may take some time.';
    popWaitMessage += ' Please wait...';

    popWin({
        popID: 'popInvoicesGenerating'
        ,title: popTitle
        ,modal: true
        ,hideCloseButton: false
        ,closeOnEscape: true
        ,width: 600
        ,noAutoWidth: true
        ,contents: loadingBox({
            classes: 'popEmailLoading',
            waitMessage: popWaitMessage,
        }),
    });

    var formObj = $('#frmInvoiceReprint');

    formObj.find("[name='invoiceNoFrom']").val(invoiceID);
    formObj.find("[name='invoiceNoTo']").val(invoiceID);
    formObj.find("[name='invoiceDateFrom']").val(invoiceDate);
    formObj.find("[name='invoiceDateTo']").val(invoiceDate);
    formObj.find("[name='horse_ID']").val('');
    formObj.find("[name='owner_ID']").val(ownerID);
    formObj.find("[name='stallion_ID']").val('');
    formObj.find("[name='BillingCentreID']").val(billingCentreID);
    formObj.find("[name='reportFormat']").val('pdf');

    if (invoiceType == 'K'){
        // Legacy Keep Invoice Creation
        formObj.attr('action', '/pages/report_generic.cfm');
        formObj.find("[name='reportname']").val('billing_invoice_reprint');
        formObj.find("[name='report']").val('billing_invoice_reprint');
        var keepOnly = true;
        var stallionOnly = false;
    } else {
        // Nomination Invoice
        formObj.attr('action', '/pages/report_stallion_main.cfm');
        formObj.find("[name='reportname']").val('report_stallion_reprint_invoices');
        formObj.find("[name='report']").val('report_stallion_reprint_invoices');
        var keepOnly = false;
        var stallionOnly = true;
    }

    var checkReportMatchesURL = '/components/billing.cfc?' + jQuery.param({
        'method': 'checkInvoiceHistory',
        'invoiceNoFrom': invoiceID,
        'invoiceNoTo': invoiceID,
        'invoiceDateFrom': invoiceDate,
        'invoiceDateTo': invoiceDate,
        'ownerIDs': ownerID,
        'billingCentreID': billingCentreID,
        'keepOnly': keepOnly,
        'stallionOnly': stallionOnly,
    });

    $.ajax({
        type: 'GET',
        url: checkReportMatchesURL,
        data: gen_random(),
        dataType: 'JSON',
        cache: false,
        success: function(data){

            var checkResult = {};
            if (data && typeof data === 'object') {
                $.each(data, function(key, value) {
                    checkResult[String(key).toLowerCase()] = value;
                });
            }

            var totalRecords = parseInt(checkResult.totalrecords, 10) || 0;

            if (totalRecords > 0){
                // Show Report
                popWinClose('popInvoicesGenerating');
                formObj.submit();
            } else {
                //No matching records found
                EQLAPP.STRIPE.showAlert({
                    title: 'equisoft Live - Invoice Result',
                    body: 'No matching invoices found.',
                });
                popWinClose('popInvoicesGenerating');
            }
        },
        error: function(){
            popWinClose('popInvoicesGenerating');
            EQLAPP.STRIPE.showAlert({
                title: 'Warning',
                body: 'Unable to connect to Equisoft Live at this time. Please try again.',
            });
        },
    });

}

export function horseBillingCategoryUpdateGrid(options){

    if (!options.selector || !options.grid || !options.pager
        || !options.pagerSetting || !options.horseCounterSelector){
        console.log('Missing Grid Options for Bill Category Grid');
        var alertBody = 'Unable to update grid. Please reload and try again';
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: alertBody});
        return false;
    };
    if (!options.startRows){
        options.startRows = 10;
    };
    if (!options.width){
        options.width = 730;
    };

    $(options.selector).jqGrid({
        datatype: 'local',
        caption: '',
        autowidth: false,
        width: options.width,
        height: '100%',
        pager: options.pager,
        viewrecords: true,
        multiselect: true,
        colNames: [
            'ID',
            'Name',
            'Status',
            'DOB',
            'Category',
            'Last Vet',
            'Last Farrier',
            'Last Misc',
            'Invoiced',
        ],
        colModel: [
            {
                name: 'ID', index: 'ID',
                align: 'left', width: 15,hidden: true,
            },
            {
                name: 'NAME', index: 'NAME',
                align: 'left', search: true, width: 20, sorttype: 'text',
                classes: 'nowrap horse_search',
                searchoptions: {dataInit: resizeFilterToolbarInput},
            },
            {
                name: 'STATUS', index: 'horseStatusDesc',
                align: 'left', search: true,width: 15, sorttype: 'text',
                classes: 'horse_search',
                searchoptions: {dataInit: resizeFilterToolbarInput},
            },
            {
                name: 'DOB', index: 'DATEOFBIRTH',
                align: 'center', width: 10,sorttype: 'text',
            },
            {
                name: 'BILLCATEGORY', index: 'BillCategoryDescription',
                align: 'left', search: true,width: 15, sorttype: 'text',
                classes: 'horse_search',
                searchoptions: {dataInit: resizeFilterToolbarInput},
            },
            {
                name: 'LASTVET', index: 'LastVetDate',
                align: 'center', width: 10,sorttype: 'text',
            },
            {
                name: 'LASTFARRIER', index: 'LastFarrierDate',
                align: 'center', width: 10,sorttype: 'text',
            },
            {
                name: 'LASTMISC', index: 'LastMiscDate',
                align: 'center', width: 10,sorttype: 'text',
            },
            {
                name: 'LASTINVOICE', index: 'LastInvoiceDate',
                align: 'center', width: 10,sorttype: 'text',
            },
        ],
        rowNum: options.startRows,
        rowList: [10,15,20],
        gridComplete: function(){
            gridFix(options.selector);
        },
        loadComplete: function(data){
            var recCount = $('#' + options.pager).find('.ui-pg-selbox').val();
            setMiscSetting(options.pagerSetting,recCount);
            const ids = $(this).jqGrid('getDataIDs');
            for (const id of ids) {
                if (billCategoryUpdateSelectedHorses.has(id)) {
                    $(this).jqGrid('setSelection', id, false);
                }
            }
            // Trigger Resize
            window.dispatchEvent(new Event('resize'));

            var myGrid = $(options.selector);
            var recordAllPages = myGrid.jqGrid('getGridParam', 'records');
            $(options.horseCounterSelector)
                .text(billCategoryUpdateSelectedHorses.size + ' of ' + recordAllPages);
        },
        onSelectRow: function(id, isSelected) {

            var myGrid = $(options.selector);
            var recordAllPages = myGrid.jqGrid('getGridParam', 'records');

            if (isSelected) {
                billCategoryUpdateSelectedHorses.add(id);
            } else {
                billCategoryUpdateSelectedHorses.delete(id);
            }
            $(options.horseCounterSelector)
                .text(billCategoryUpdateSelectedHorses.size + ' of ' + recordAllPages);
        },
        onSelectAll: function(aRowids,status)
        {
            var myGrid = $(options.selector);
            var recordAllPages = myGrid.jqGrid('getGridParam', 'records');
            var recordCurrentPage = myGrid.jqGrid('getGridParam', 'reccount');
            if (status)
            {
                if (recordAllPages > recordCurrentPage)
                {
                    aRowids.forEach((item, index) => {
                        billCategoryUpdateSelectedHorses.add(item);
                    });
                }
            }
            else
            {
                aRowids.forEach((item, index) => {
                    billCategoryUpdateSelectedHorses.delete(item);
                });
            }
            $(options.horseCounterSelector)
                .text(billCategoryUpdateSelectedHorses.size + ' of ' + recordAllPages);

        },
    });
}

export function getBillCategoryUpdateSelectedHorses(){
    return billCategoryUpdateSelectedHorses;
}

export function resetBillCategoryUpdateSelectedHorses(){
    billCategoryUpdateSelectedHorses.clear();
}

export function superTest(){
    EQLAPP.STRIPE.showAlert({
        title: 'Invoice PDF',
        body: 'Super Test!',
    });
}
export function calculateTotal(a, b) {
    return a + b;
}
